import fileSaver from 'file-saver';
import t from './CustomModule.type';
import * as customModuleService from '../../../../services/custom-module.services';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

export const addCustomModule = (params, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await customModuleService.insertCustomModule({ data: dataString });
    if (chunkSuccessful && chunkSuccessful.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg?.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateCustomModule = (params, id, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await customModuleService.editCustomModuleById({ data: dataString }, id);
    if (chunkSuccessful?.code === 200) {
      const msg = transactionMsg(chunkSuccessful.message);
      toasterMsg(msg, 'success');
    } else {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllCustomModule = (params) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModule({ params });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCustomModuleById = (libId, pageId) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModuleId(libId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCustomModuleLibrary = (libIds, transactionMsg) => async () => {
  try {
    const res = await customModuleService.deleteCustomModuleLibrary(libIds);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.data?.errMsg}`);
      toasterMsg(msg.toString(), 'danger');
    }

    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_LIBRARY_LIST = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_LIBRARY_LIST,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addCustomModuleGroup = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await customModuleService.insertCustomModuleGroup(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(transactionMsg(msg.toString()), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllCustomModuleGroup = (params) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModuleGroup({ params });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_GROUP,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_GROUP_LIST = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_GROUP_LIST,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCustomModuleGroupById = (libId) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModuleGroupId(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateCustomModuleGroup = (params, id, transactionMsg) => async (dispatch) => {
  try {
    const res = await customModuleService.editCustomModuleGroupById(params, id);
    if (res?.code === 200) {
      const msg = transactionMsg(res.message);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCustomModuleGroup = (libIds, transactionMsg) => async () => {
  try {
    const res = await customModuleService.deleteCustomModuleGroup(libIds);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addLibraryToGroup = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await customModuleService.addLibraryToCustomModuleGroup(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(transactionMsg(msg.toString()), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const duplicateCustomModuleLibrary = (data, transactionMsg) => async () => {
  try {
    const res = await customModuleService.duplicateCustomModuleLibrary(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getOptionCustomModuleById = (libId) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModuleId(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_FOR_OPTION,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmountLibrary = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_LIBRARY,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadSampleFile = () => async () => {
  try {
    const res = await customModuleService.exportExcelService();
    if (res) {
      fileSaver.saveAs(res, 'Custom Module Table Sample');
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res?.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(error.toString(), 'danger');
  }
};

export const activeInactiveCustomModuleLibrary = (data, transactionMsg) => async () => {
  try {
    const res = await customModuleService.activeInactive(data); // API

    if (res.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveLibraryPages = (pagesData) => async (dispatch) => {
  try {
    await dispatch({
      type: t.LIBRARY_PAGES,
      payload: pagesData,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadCMImage = (data) => async () => {
  try {
    const res = await customModuleService.uploadCMImageS3(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCMImage = (data, transactionMsg) => async () => {
  try {
    const res = await customModuleService.deleteCMImageFromS3(data);
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getNewMongoId = () => async () => {
  try {
    const res = await customModuleService.getNewPageId();
    if (res.code === 200) {
      return res.data;
    }
    return null;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// delete custom module page
export const deleteCustomLibraryPage = (params, transactionMsg) => async () => {
  try {
    const res = await customModuleService.deleteCustomModuleLibraryPage(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.data?.errMsg}`);
      toasterMsg(msg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCMPageList = (libId) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModuleList(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePageSequence = (data, libId, transactionMsg) => async () => {
  try {
    const res = await customModuleService.updateLibraryPageSequence(data, libId);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getContentPageData = (libId) => async () => {
  try {
    const res = await customModuleService.getCustomModuleContentPage(libId);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get PageControls
export const getCMPageControlList = (customModuleLibId, pageId) => async (dispatch) => {
  try {
    const res = await customModuleService.getPageControls(customModuleLibId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const getCMPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await customModuleService.getSrcPages(customModuleLibId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_PAGE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get depdnent Control Lists
export const getDependentPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await customModuleService.getDependentControlsList(customModuleLibId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_DEPENDENT_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getLibraryCMContentPage = (libId) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModuleContentData(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get all custom module for calculation
export const getAllCustomModuleForCalculations = (params) => async (dispatch) => {
  try {
    const res = await customModuleService.getCustomModule({ params });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_CUSTOM_MODULE_FOR_CALCULATION,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// clear custom module for calculation
export const clearCalculationList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_ALL_CUSTOM_MODULE_FOR_CALCULATION,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// calculation page List Api
export const getCalculationPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await customModuleService.getSrcPages(customModuleLibId, { withoutCP: true });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// clear custom module for calculation
export const clearCalculationPageList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get PageControls
export const getCalculationPageControlList = (customModuleLibId, pageId) => async (dispatch) => {
  try {
    const res = await customModuleService.getPageCalculationControls(customModuleLibId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearCalculationControlList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const previewSampleFile = (data) => async () => {
  try {
    const res = await customModuleService.previewTemplateService(data);
    if (res.data && res.code === 200) {
      return res;
    }
    toasterMsg(res.message, 'danger');
  } catch (error) {
    toasterMsg(error, 'danger');
  }
};

export const activeInactiveCustomModuleGroup = (objData, translationFunc) => async () => {
  try {
    const res = await customModuleService.activeInactiveCustomModuleGroup(objData);
    if (res?.code === 200) {
      toasterMsg(translationFunc('CUSTOM_MODULES.GROUP.CUSTOM_LIST.STATUS_UPDATED_SUCCESS'), 'success');
      return res;
    }
    toasterMsg(res.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};
